export default "__VITE_ASSET__d4f52fe6__"